import { style } from '@do/walrus';

import defaultsDeep from 'lodash/defaultsDeep';
import defaultBg from './assets/backgrounds/HeroBackground-Option1-01.png';
import defaultBg2 from './assets/backgrounds/HeroBackground-Option2-01.png';
import defaultBg3 from './assets/backgrounds/HeroBackground-Option3-01.png';

import newBrandBg from './assets/backgrounds/new-brand-bg.png';
import ghStudentBg from './assets/partners/github/github_student_bg.png';
import ghStudentLogo from './assets/partners/github/github_student_logo.png';
import copy from './copy';

//import dropletConsoleBg from './assets/backgrounds/droplet-console-BG.svg';
//import dropletConsoleLogo from './assets/droplet-console-logo.png';

import {
  ButtonVariations,
  Variant,
  VariationTemplates
} from './interfaces/variant';

interface VariantMap {
  [id: string]: Variant;
}

const defaults = {
  type: 'default',
  textColor: 'white',
  background: {
    image: defaultBg,
    horizontalPosition: 'center',
    verticalPosition: 'center',
    height: '180px',
    width: '360px'
  },
  title: copy.form.newBrandDesign.login_title,
  preferredLoginTitle: copy.form.newBrandDesign.preferred_login_title,
  subtitle: '',
  preferredLoginSubtitle: copy.form.preferred_login_details
};

export const newBg2 = defaultsDeep(
  {
    type: 'newBg2',
    background: {
      image: defaultBg2
    }
  },
  defaults
);

export const newBg3 = defaultsDeep(
  {
    type: 'newBg3',
    background: {
      image: defaultBg3
    }
  },
  defaults
);

export const teamVariant = defaultsDeep(
  {
    type: 'team',
    title: 'Join your team on DigitalOcean!',
    subtitle:
      '{{name}} has invited you to join them. Sign in and start making waves with your team today!'
  },
  defaults
);

/*
To be used for the new "split" format promotions

export const dropletConsole = defaultsDeep({
  type: 'dropletConsole',
  version: VariationTemplates.SPLIT,
  background: {
    image: dropletConsoleBg
  },
  image: dropletConsoleLogo,
  title: 'Introducing the new Droplet Console',
  subtitle: 'A new browser-based way to connect to Droplets.',
  textColor: colors.grey_light,
  align: 'left',
  button: {
    variation: ButtonVariations.PRIMARY,
    text: 'Learn more',
    url: 'https://www.digitalocean.com/blog/new-droplet-console-ssh-support/'
  }
});*/

export const newBrand = defaultsDeep(
  {
    type: 'newBrand',
    version: VariationTemplates.NEW_BRAND,
    background: {
      image: newBrandBg
    }
  },
  defaults
);

export const githubLoginVariation = defaultsDeep(
  {
    type: 'githubStudentPack',
    version: VariationTemplates.NEW_BRAND,
    title: 'Log into your account',
    preferredLoginTitle: 'Log into your account',
    subtitle:
      'In order to claim your credits please log in to your DigitalOcean account',
    preferredLoginSubtitle: 'In order to claim your credits please log in',
    background: {
      color: '#eff2fb'
    },
    splash: {
      type: 'ghPartner',
      version: VariationTemplates.SPLIT,
      background: {
        image: ghStudentBg
      },
      image: ghStudentLogo,
      title: 'GitHub Student Developer Pack',
      subtitle:
        /* eslint-disable-next-line @do/no-hardcoded-prices */
        'As a part of GitHub student developer pack, you will receive $100 in credit that are valid for 1 year. Once you sign up you will be prompet to verify your GitHub account',
      textColor: style.colors.grey.darkest,
      button: {
        variation: ButtonVariations.SECONDARY,
        text: 'Learn more',
        fullWidth: true,
        url:
          'https://www.digitalocean.com/blog/new-droplet-console-ssh-support/'
      }
    }
  },
  defaults
);

// These are for randomly choosing login variants
const loginVariants: VariantMap = {
  primary: newBg2,
  newBg3
};

export default loginVariants;
